<template>
  <v-container fluid>
    <v-card class="ui-module-card ui-module-fade-in-up preaspirantes-shell" color="primary">
      <v-card-text>
        <v-row>
          <v-col cols="7" align="right">
            <TextButton
              class="secondary ui-module-btn-solid ui-module-fade-in-up py-y mt-4 px-8"
              rounded
              elevation="8"
              to="/profesionalizacion/registro_preaspirante"
            >
              Registrar aspirante <v-icon small class="ml-2">mdi-plus</v-icon>
            </TextButton>
          </v-col>
          <v-col cols="12" lg="5">
            <v-text-field
              class="ui-form-field mt-2"
              v-model="buscaPreaspirante"
              color="secondary"
              background-color="transparent"
              rounded
              filled
              hide-details
              placeholder="Buscar aspirante"
              append-icon="mdi-magnify"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row v-if="preaspirantes.length > 0">
          <v-col cols="12" v-if="buscaPreaspirante.length > 0">
            <div class="text-h6 font-weight-bold">
              {{ filteredPreaspirantes.length }} resultados encontrados con la búsqueda "{{ buscaPreaspirante }}"
            </div>
          </v-col>
          <v-expansion-panels flat class="ui-module-card" focusable hover mandatory>
            <v-expansion-panel v-for="(grupoPreaspirantes, index) in groupedPreaspirantes" :key="index">
              <v-expansion-panel-header>
                <div>
                  <div class="text-h6 secondary--text font-weight-bold d-inline">
                    {{ grupoPreaspirantes.inicial }}
                  </div>
                  <div class="text-overline d-inline secondary--text">
                    ({{ grupoPreaspirantes.preaspirantes.length }})
                  </div>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-container>
                  <v-row>
                    <v-col
                      cols="12"
                      lg="4"
                      xl="3"
                      v-for="preaspirante in grupoPreaspirantes.preaspirantes"
                      :key="preaspirante.id"
                    >
                      <v-card class="ui-module-card ui-module-fade-in-up" color="secondary" elevation="8">
                        <v-card-title>
                          <v-container>
                            <v-row>
                              <v-col cols="12" align="center">
                                <v-avatar rounded color="primary" size="80">
                                  <v-icon x-large color="secondary">mdi-account</v-icon>
                                </v-avatar>
                              </v-col>
                              <v-col cols="12" align="center">
                                <div class="text-h6 primary--text font-weight-bold">{{ preaspirante.apaterno }}</div>
                                <div class="text-subtitle-1 primary--text">
                                  {{
                                    preaspirante.amaterno + ' ' + preaspirante.nombre + ' ' + preaspirante.segundoNombre
                                  }}
                                </div>
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-card-title>
                        <v-card-text>
                          <!-- <v-container>
                                                <v-row>
                                                    <v-col cols="12" align="center">
                                                        <div class="text-caption primary--text">Radica en</div>
                                                        <div class="text-overline primary--text " v-if="preaspirante.CatMunicipioRadica.CatEstado">
                                                            {{
                                                                preaspirante.CatMunicipioRadica.nombre +
                                                                    ', ' +
                                                                    preaspirante.CatMunicipioRadica.catEstado.title
                                                            }}
                                                        </div>
                                                        <div class="text-overline text--secondary" v-else>
                                                            No definido
                                                        </div>
                                                    </v-col>
                                                    <v-col cols="12" align="center">
                                                        <div class="text-caption primary--text">Nació en</div>
                                                        <div class="text-overline primary--text " v-if="preaspirante.CatMunicipioNacimiento.CatEstado">
                                                            {{
                                                                preaspirante.CatMunicipioNacimiento.nombre +
                                                                    ', ' +
                                                                    preaspirante.CatMunicipioNacimiento.catEstado.title
                                                            }}
                                                        </div>
                                                        <div class="text-overline text--secondary" v-else>No definido</div>
                                                    </v-col>
                                                    <v-col cols="12" align="center">
                                                        <div class="text-caption primary--text">Edad</div>
                                                        <div class="text-overline primary--text " v-if="preaspirante.fechaNacimiento != ''">
                                                            {{ getAge(preaspirante.fechaNacimiento) + ' años' }}
                                                        </div>
                                                        <div class="text-overline text--secondary" v-else>
                                                            No definido
                                                        </div>
                                                    </v-col>
                                                </v-row>
                                            </v-container> -->
                          <v-sheet color="transparent" height="120"></v-sheet>
                        </v-card-text>
                        <v-card-actions class="secondary darken-1 ui-module-actions">
                          <v-container>
                            <v-row>
                              <v-col cols="1">
                                <v-tooltip bottom color="black">
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                      class="primary error--text mx-2 ui-module-icon-action"
                                      elevation="8"
                                      :to="{ name: 'archivarPreaspirante', params: { id: preaspirante.idPersonal } }"
                                      icon
                                      v-on="on"
                                      v-bind="attrs"
                                    >
                                      <v-icon>mdi-archive-arrow-down</v-icon>
                                    </v-btn>
                                  </template>
                                  <span>Archivar preaspirante</span>
                                </v-tooltip>
                              </v-col>
                              <v-col cols="11" align="right">
                                <v-tooltip bottom color="black">
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                      class="primary secondary--text mx-2 ui-module-icon-action"
                                      elevation="8"
                                      :to="{ name: 'agendaCita', params: { id: preaspirante.idPersonal } }"
                                      icon
                                      v-on="on"
                                      v-bind="attrs"
                                      ><v-icon>mdi-calendar</v-icon></v-btn
                                    >
                                  </template>
                                  <span>Agendar cita de evaluación</span>
                                </v-tooltip>
                                <v-tooltip bottom color="black">
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                      class="primary secondary--text mx-2 ui-module-icon-action"
                                      elevation="8"
                                      :to="{ name: 'evaluacionMedica', params: { id: preaspirante.idPersonal } }"
                                      icon
                                      v-on="on"
                                      v-bind="attrs"
                                      ><v-icon>mdi-medical-bag</v-icon></v-btn
                                    >
                                  </template>
                                  <span>Realizar evaluación</span>
                                </v-tooltip>
                                <v-tooltip bottom color="black">
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                      class="primary secondary--text mx-2 ui-module-icon-action"
                                      elevation="8"
                                      :to="{ name: 'documentosPreaspirante', params: { id: preaspirante.idPersonal } }"
                                      icon
                                      v-on="on"
                                      v-bind="attrs"
                                      ><v-icon>mdi-file-account</v-icon></v-btn
                                    >
                                  </template>
                                  <span>Ver expediente</span>
                                </v-tooltip>
                                <v-tooltip bottom color="black">
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                      class="primary secondary--text mx-2 ui-module-icon-action"
                                      elevation="8"
                                      :to="{ name: 'validaPreaspirante', params: { id: preaspirante.idPersonal } }"
                                      icon
                                      v-on="on"
                                      v-bind="attrs"
                                      ><v-icon>mdi-check</v-icon></v-btn
                                    >
                                  </template>
                                  <span>Validar preaspirante</span>
                                </v-tooltip>
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-card-actions>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-container>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-row>
        <v-row v-else>
          <v-col cols="12" align="center">
            <div class="text-h6 font-weight-bold">No hay aspirantes registrados</div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import _ from 'lodash'
import TextButton from '@/components/base/TextButton.vue'

export default {
  components: {
    TextButton,
  },
  data() {
    return {
      buscaPreaspirante: '',
      ordenAlfabetico: 0,
    }
  },

  computed: {
    ...mapGetters('preaspirante', {
      preaspirantes: 'getPreaspirantes',
    }),

    filteredPreaspirantes: function () {
      return this.preaspirantes.filter((preaspirante) => {
        return (
          preaspirante.nombre.toLowerCase().indexOf(this.buscaPreaspirante.toLowerCase()) >= 0 ||
          preaspirante.segundoNombre.toLowerCase().indexOf(this.buscaPreaspirante.toLowerCase()) >= 0 ||
          preaspirante.apaterno.toLowerCase().indexOf(this.buscaPreaspirante.toLowerCase()) >= 0 ||
          preaspirante.amaterno.toLowerCase().indexOf(this.buscaPreaspirante.toLowerCase()) >= 0 ||
          this.getAge(preaspirante.fechaNacimiento) == this.buscaPreaspirante
          // (preaspirante.CatMunicipioRadica && preaspirante.CatMunicipioRadica.nombre.toLowerCase().indexOf(this.buscaPreaspirante.toLowerCase()) >= 0) ||
          // (preaspirante.CatMunicipioRadica &&
          //     preaspirante.CatMunicipioRadica.CatEstado.title.toLowerCase().indexOf(this.buscaPreaspirante.toLowerCase()) >= 0)
          // (preaspirante.CatMunicipioNacimiento &&
          //     preaspirante.CatMunicipioNacimiento.nombre.toLowerCase().indexOf(this.buscaPreaspirante.toLowerCase()) >= 0) ||
          // (preaspirante.CatMunicipioNacimiento &&
          //     preaspirante.CatMunicipioNacimiento.CatEstado.title.toLowerCase().indexOf(this.buscaPreaspirante.toLowerCase()) >= 0)
        )
      })
    },

    groupedPreaspirantes: function () {
      var result = _(this.filteredPreaspirantes)
        .groupBy((preaspirante) => preaspirante.apaterno[0].toUpperCase())
        .map((preaspirantes, inicial) => ({ inicial, preaspirantes }))
        .value()

      if (this.ordenAlfabetico == 0) {
        result.sort(function (a, b) {
          if (a.inicial < b.inicial) {
            return -1
          }
          if (a.inicial > b.inicial) {
            return 1
          }
          return 0
        })
      } else {
        result.sort(function (a, b) {
          if (a.inicial > b.inicial) {
            return -1
          }
          if (a.inicial < b.inicial) {
            return 1
          }
          return 0
        })
      }
      return result
    },
  },

  methods: {
    getFullName: function (preaspirante) {
      return (
        preaspirante.nombre +
        ' ' +
        preaspirante.segundoNombre +
        ' ' +
        preaspirante.apaterno +
        ' ' +
        preaspirante.amaterno
      )
    },
  },
}
</script>

<style scoped>
.preaspirantes-shell {
  min-height: calc(100vh - 64px);
  min-height: calc(100dvh - 64px);
}

/* Estilos modernos para Preaspirantes (Control de Aspirantes) */
.fab {
  position: fixed;
  bottom: 24px;
  right: 24px;
}

/* Botón de registro */
::v-deep .v-btn.secondary {
  background: linear-gradient(135deg, #00d2a0 0%, #26de81 100%) !important;
  color: #ffffff !important;
  box-shadow: 0 4px 16px rgba(0, 210, 160, 0.4) !important;
  border-radius: 12px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) !important;
  position: relative;
  overflow: hidden;
}

::v-deep .v-btn.secondary:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(0, 210, 160, 0.6) !important;
}

/* Input de búsqueda */
::v-deep .ui-form-field .v-input__slot {
  border-radius: 12px !important;
  border: 1px solid rgba(0, 210, 160, 0.25) !important;
  background: rgba(16, 16, 30, 0.35) !important;
  transition: all 0.3s ease !important;
}

::v-deep .ui-form-field .v-input__slot:hover {
  border-color: rgba(0, 210, 160, 0.45) !important;
}

::v-deep .ui-form-field .v-input__control {
  background: transparent !important;
  border-radius: 12px;
  border: none !important;
  box-shadow: none !important;
}

::v-deep .ui-form-field.v-input--is-focused .v-input__control {
  border: none !important;
  box-shadow: none !important;
}

::v-deep .ui-form-field input {
  color: #e0e0e0 !important;
}

::v-deep .ui-form-field input::placeholder {
  color: rgba(224, 224, 224, 0.5) !important;
}

::v-deep .ui-form-field .v-label,
::v-deep .ui-form-field .mdi-magnify {
  color: rgba(38, 222, 129, 0.75) !important;
}

::v-deep .ui-form-field.v-input--is-focused .v-label {
  color: #26de81 !important;
}

/* Botón toggle de orden */
::v-deep .v-btn-toggle {
  background: rgba(26, 46, 36, 0.6) !important;
  border: 1px solid rgba(0, 210, 160, 0.2);
  border-radius: 12px;
}

::v-deep .v-btn-toggle .v-btn {
  border-radius: 12px !important;
}

::v-deep .v-btn-toggle .v-btn--active {
  background: rgba(0, 210, 160, 0.2) !important;
}

/* Títulos y textos */
.text-h6 {
  color: #e0e0e0 !important;
  font-weight: 700;
}

.secondary--text {
  color: #26de81 !important;
}

.primary--text {
  color: #e0e0e0 !important;
}

.text-overline {
  color: rgba(224, 224, 224, 0.7) !important;
}

/* Expansion Panels */
::v-deep .v-expansion-panel {
  background: rgba(26, 46, 36, 0.4) !important;
  border: 1px solid rgba(0, 210, 160, 0.15);
  border-radius: 16px !important;
  margin-bottom: 12px;
  transition: all 0.3s ease;
}

::v-deep .v-expansion-panel:hover {
  background: rgba(26, 46, 36, 0.6) !important;
  border-color: rgba(0, 210, 160, 0.3);
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(0, 210, 160, 0.2);
}

::v-deep .v-expansion-panel-header {
  color: #e0e0e0 !important;
  padding: 20px 24px;
  border-radius: 16px !important;
}

::v-deep .v-expansion-panel-header:hover {
  background: rgba(0, 210, 160, 0.08) !important;
}

::v-deep .v-expansion-panel-content__wrap {
  padding: 16px 24px 24px;
}

/* Cards de preaspirantes */
::v-deep .v-card {
  background: rgba(26, 46, 36, 0.6) !important;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(0, 210, 160, 0.2);
  border-radius: 16px;
  transition: all 0.3s ease;
}

::v-deep .v-card:hover {
  border-color: rgba(0, 210, 160, 0.4);
  transform: translateY(-4px) scale(1.02);
  box-shadow: 0 12px 32px rgba(0, 210, 160, 0.3) !important;
}

::v-deep .v-card-title {
  color: #e0e0e0 !important;
  padding: 16px;
  background: rgba(0, 210, 160, 0.08);
  border-bottom: 1px solid rgba(0, 210, 160, 0.2);
}

::v-deep .v-card-text {
  color: #e0e0e0 !important;
}

::v-deep .v-card-actions {
  background: rgba(0, 210, 160, 0.08) !important;
  border-top: 1px solid rgba(0, 210, 160, 0.1);
}

/* Avatares */
::v-deep .v-avatar {
  border: 2px solid rgba(0, 210, 160, 0.3);
  transition: all 0.3s ease;
  background: rgba(0, 210, 160, 0.15) !important;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
}

::v-deep .v-card:hover .v-avatar {
  transform: rotate(5deg) scale(1.1);
  border-color: #00d2a0;
  box-shadow: 0 8px 24px rgba(0, 210, 160, 0.4);
}

::v-deep .v-avatar .v-icon {
  color: #26de81 !important;
  filter: drop-shadow(0 4px 12px rgba(0, 210, 160, 0.4));
}

/* Botones */
::v-deep .v-btn {
  border-radius: 12px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) !important;
  position: relative;
  overflow: hidden;
}

::v-deep .v-btn::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  transform: translate(-50%, -50%);
  transition: width 0.6s, height 0.6s;
  pointer-events: none;
}

::v-deep .v-btn:active::before {
  width: 300px;
  height: 300px;
}

::v-deep .v-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(0, 210, 160, 0.6) !important;
}

::v-deep .v-btn.primary {
  background: rgba(26, 46, 36, 0.8) !important;
  border: 1px solid rgba(0, 210, 160, 0.3);
}

::v-deep .v-btn.primary:hover {
  background: rgba(26, 46, 36, 0.95) !important;
  border-color: #00d2a0;
}

::v-deep .v-btn.error--text {
  color: #ff5252 !important;
}

::v-deep .v-btn.error--text:hover {
  background: rgba(255, 82, 82, 0.1) !important;
}

::v-deep .v-btn.secondary--text {
  color: #00d2a0 !important;
}

::v-deep .v-btn icon {
  transition: all 0.3s ease;
}

::v-deep .v-btn:hover .v-icon {
  transform: scale(1.2);
}

/* Tooltips */
::v-deep .v-tooltip__content {
  background: rgba(26, 46, 36, 0.95) !important;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(0, 210, 160, 0.3);
  border-radius: 8px;
  color: #e0e0e0 !important;
  font-weight: 500;
  padding: 8px 12px;
}

/* V-sheet transparente */
::v-deep .v-sheet {
  background: transparent !important;
}

/* Scrollbar */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: rgba(10, 10, 10, 0.5);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: rgba(0, 210, 160, 0.4);
  border-radius: 4px;
  transition: background 0.3s;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 210, 160, 0.6);
}
</style>
